import {
  DomainName,
  IRichTextInputControl,
  StringDomain,
  TControlName,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LocalizedProps,
  RichTextFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSource } from '../../view-model/FormSource';

import { controlDomain, getValueFromArgsOrConfig } from './helpers';

const buildRichTextControl = async (
  item: IRichTextInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<RichTextFormControlViewModel> => {
  const domain = (await controlDomain(item, source, domains)) as StringDomain;
  return {
    columns: item.columns,
    noLabel: item.noLabel,
    type: FormControlViewModelType.RICHTEXT,
    name: item.name,
    hasValue: true,
    hasHistory: false,
    hideMenu: item.hideMenu,
    hideToolbar: item.hideToolbar,
    value: getValueFromArgsOrConfig(item, args, source, ''),
    labelWidth: item.labelWidth,
    lengthInBytes: domain.lengthInBytes,
    maxLength: domain.length,
    required: item.required,
    disabled: item.disabled,
    visible: item.visible,
    storeValue: item.storeValue,
    readonly: item.readonly,
    rows: item.rows || 3,
    trim: item.trim,
    ...localizedProps,
  };
};

export default buildRichTextControl;
